<template>
  <section>
    <!--工具条-->
    <el-col :span="4" class="toolbar">
      <el-button type="primary" size="small" @click="addFormVisible = true">新增</el-button>
    </el-col>

    <el-table :data="tableData"
              v-loading="listLoading">
      <el-table-column
        label="广告名称"
        prop="adver_name"
        align="center">
      </el-table-column>
      <el-table-column
        label="开始时间"
        prop="start_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="结束时间"
        prop="end_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        align="center">
        <template scope="scope">
          <el-button :plain="true" type="info" size="small" @click="addPic(scope.row)">新增图片</el-button>
          <el-button :plain="true" type="info" size="small" @click="showEditForm(scope.row)">修改</el-button>
          <el-button :plain="true" type="danger" size="small" @click="deleteDate(scope.row.adver_id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible">
      <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
        <el-form-item label="广告名称" prop="adver_name">
          <el-input v-model="addForm.adver_name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker
            v-model="addForm.start_time"
            type="datetime"
            placeholder="选择开始时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker
            v-model="addForm.end_time"
            type="datetime"
            placeholder="选择结束时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
      <el-form :model="editForm" label-width="200px" :rules="formRules" ref="editForm">
        <el-form-item label="广告名称" prop="adver_name">
          <el-input v-model="editForm.adver_name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="开始时间" prop="start_time">
          <el-date-picker
            v-model="editForm.start_time"
            type="datetime"
            placeholder="选择开始时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end_time">
          <el-date-picker
            v-model="editForm.end_time"
            type="datetime"
            placeholder="选择结束时间"
            size="small"
            format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import {formatPara} from '../../static/js/util.js';

  export default {
    data() {
      return {
        tableData: [],
        total:0,
        page:1,
        pageSize:15,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        addForm: {
          adver_name: '',
          start_time: '',
          end_time: '',
          create_time: '',
          status: 0
        },
        editFormVisible: false,
        editForm: {},
        formRules: {}
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getAdver(this.query);
      },
      getAdver(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/adver/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
          } else {
            this.$message({
              message: data.msg,
              type: 'warning'
            });
          }
          this.listLoading = false;
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'warning'
          });
        })
      },
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.addForm));
              //异步请求
              this.$axios.post(config.api_url + '/adver',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'warning'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.editForm));
              //异步请求
              this.$axios.put(config.api_url + '/adver',
                para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: response.data.msg,
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      deleteDate(id) {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.delete(config.api_url + '/adver/' + id
          ).then(response => {
            if(response.data.state) {
              this.$message({
                message: '删除成功',
                type: 'success'
              });
              this.search();
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              });
            }
          }).catch(error => {
            this.$message({
              message: '删除异常，请联系管理员',
              type: 'error'
            });
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      showEditForm(row) {
        this.editFormVisible = true;
        this.editForm = row;
      },
      addPic(row) {
        this.$router.push({ path: '/slide/'+row.adver_id });
      }
    },
    created() {
      this.search();
    }
  }
</script>



// WEBPACK FOOTER //
// Adver.vue?10e12e07